import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import CssBaseline from "@mui/material/CssBaseline";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import "./styles/App.css";
import Header from "./Header";
import Footer from "./Footer";

import "./styles/Typography.css";

// The TV details that are matched from the barcode or details input are stored
// here as state. Using the Outlet component from react-router with the context
// the setMatchedTv function is used in the Scan component and the state variable
// matchedTv is used on the TVMatch component to render the matched details.

const theme = createTheme({
    breakpoints: {
        values: {
            xs: 0,
            xsm: 340,
            sm: 600,
            md: 900,
            lg: 1200,
            xl: 1536,
        },
    },
    typography: {
        fontSize: 16,
        fontFamily: '"CeraPro",sans-serif',
        h1: {
            fontSize: 24,
            fontWeight: 700,
        },
    },
    palette: {
        warning: {
            main: "#4991E5",
        },
        success: {
            main: "#33AD5B",
        },
    },
    classNames: {
        resultModelText: {
            margin: 0,
            textAlign: "center",
        },
        resultMainText: {
            fontSize: "1.35rem",
            lineHeight: 1.25,
            textAlign: "center",
            fontWeight: 700,
        },
    },
    components: {
        // Name of the component ⚛️
        MuiCssBaseline: {
            styleOverrides: {
                a: {
                    textDecoration: "none",
                },
                body: {
                    maxWidth: "1366px",
                    margin: "0 auto",
                },
            },
        },
        MuiTypography: {
            styleOverrides: {
                h1: {
                    "&::after": {
                        content: "''",
                        display: "block",
                        width: "1.5em",
                        height: "0.1em",
                        margin: "0 0.07em 0.3em",
                        backgroundColor: "black",
                    },
                },
            },
        },
        MuiButton: {
            styleOverrides: {
                // Name of the slot
                root: {
                    // Some CSS
                    // borderRadius: "2rem",
                    borderTopRightRadius: "20px",
                    borderTopLeftRadius: "20px",
                    borderBottomRightRadius: "20px",
                    borderBottomLeftRadius: "20px",
                    "&.Mui-focused": {
                        borderBottomRightRadius: 0,
                        borderBottomLeftRadius: 0,
                    },
                    height: "2.5rem",
                },
            },
        },
        MuiAutocomplete: {
            styleOverrides: {
                root: {
                    borderColor: "rgba(0, 0, 0, 0)",
                },
                inputRoot: {
                    borderColor: "rgba(0, 0, 0, 0)",
                    borderRadius: "2rem",
                    backgroundColor: "#ECECEC",
                },
                popper: {
                    backgroundColor: "rgba(255, 255, 255, 1)",
                },
                paper: {
                    backgroundColor: "rgba(0, 0, 0, 0.15)",
                    borderBottomRightRadius: "20px",
                    borderBottomLeftRadius: "20px",
                },
            },
        },
        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    borderColor: "rgba(0, 0, 0, 0)",
                    "&.Mui-focused": {
                        borderColor: "rgba(0, 0, 0, 0)",
                    },
                },
                input: {
                    height: "1rem",
                },
                notchedOutline: {
                    borderColor: "rgba(0, 0, 0, 0)",
                },
            },
        },
        MuiInputLabel: {
            styleOverrides: {
                root: {
                    lineHeight: "1rem",
                },
            },
        },
    },
});

function App() {
    const [matchedTv, setMatchedTv] = useState(0);

    // Keep searched model state values
    const [manufacturerValue, setManufacturerValue] = useState("");
    const [modelValue, setModelValue] = useState("");
    const [matchedEAN, setMatchedEAN] = useState("");

    return (
        <ThemeProvider theme={theme}>
            <div className="App">
                <CssBaseline />
                <Header />
                <Outlet
                    context={{
                        matchedTv,
                        setMatchedTv,
                        manufacturerValue,
                        setManufacturerValue,
                        modelValue,
                        setModelValue,
                        matchedEAN,
                        setMatchedEAN,
                    }}
                />
                <Footer />
            </div>
        </ThemeProvider>
    );
}

export default App;
